import { Component, Input } from '@angular/core';
import { Rodeo } from '../../../../model/rodeo';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
	selector: 'page-doublebooked-report',
	templateUrl: 'report-doublebooked-list.html'
	
})
export class DoubleBookedListReport {
    @Input('rodeo') rodeo: Rodeo;
    constructor(public dateHelper: DateHelperService) { }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-doublebooked-list.ts